import{a as e,j as a}from"./chunk-ODWKAC4U.js";import{a as i}from"./chunk-XOSPBGLI.js";import{j as r,m as t}from"./chunk-HBP5N4FR.js";t();a();function p(m){return r(this,null,function*(){let n=e[m],o=yield i(n.apiAddress);return o!==null?o:n})}export{p as a};
//# sourceMappingURL=chunk-ACPP7I66.js.map
